/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import { gMap } from '../../config/googleMaps';
import { getHyphenYYYYMMDDHHMMSS } from '../common/utils';
import './optimiseroutes_new.css';

var redirectURL = require('../redirectURL');

// ── Module-level helpers ────────────────────────────────────────────────────
// Inject the Google Maps script once (project-wide pattern).
function loadScript(url) {
    var index = window.document.getElementsByTagName("script")[0];
    var script = window.document.createElement("script");
    script.src = url;
    script.async = true;
    script.defer = true;
    index.parentNode.insertBefore(script, index);
}

// String-based ag-grid cell renderer for a clickable Font Awesome icon.
function iconCell(faClass, color, title) {
    return function () {
        return '<i class="fa ' + faClass + ' orn-action-icon" title="' + (title || '')
            + '" style="cursor:pointer;font-size:16px;color:' + color + '"></i>';
    };
}

var ML_ENDPOINT = "/consignments/ml_optimized_base_routes";

var _currentYear = new Date().getFullYear();
var YEAR_OPTIONS = [];
for (var _y = _currentYear - 3; _y <= _currentYear + 1; _y++) {
    YEAR_OPTIONS.push({ label: String(_y), value: String(_y) });
}

var QUARTER_OPTIONS = [
    { label: "Q1", value: "Q1" },
    { label: "Q2", value: "Q2" },
    { label: "Q3", value: "Q3" },
    { label: "Q4", value: "Q4" },
];

// Basic email validation used by the "Email Report" popup.
var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function safeParse(value) {
    try {
        if (!value || value === "undefined" || value === "null") return [];
        if (Array.isArray(value)) return value;
        return JSON.parse(value);
    } catch (e) {
        return [];
    }
}

function normaliseRecords(rec) {
    if (Array.isArray(rec)) return rec;
    if (!rec) return [];
    if (rec.optimized_routes_data) return safeParse(rec.optimized_routes_data);
    if (rec.deviation_analysis_data) return safeParse(rec.deviation_analysis_data);
    if (rec.ignored_routes_data) return safeParse(rec.ignored_routes_data);
    if (rec.route_in_ra_data) return safeParse(rec.route_in_ra_data);
    if (rec.top_routes_unique_trips_data) return safeParse(rec.top_routes_unique_trips_data);
    if (rec.data) return safeParse(rec.data);
    if (rec.routes) return safeParse(rec.routes);
    return safeParse(rec);
}

// Mode-aware normaliser for the drill-down grids.
//  - consignments : ml_route_deviation_analysis → OBJECT; show consignments_analysis rows.
//  - baseroutes   : ml_route_deviation_analysis → OBJECT; show base_routes_anlsysis rows.
//  - ignored      : flat array of ignored trips.
//  - top          : flat array (or wrapped) of top-route trips.
function normaliseLegs(rec, gridType) {
    if (!rec) return [];
    if (gridType === 'consignments') {
        if (!Array.isArray(rec) && rec.consignments_analysis) return safeParse(rec.consignments_analysis);
        return Array.isArray(rec) ? rec : [];
    }
    if (gridType === 'baseroutes') {
        if (!Array.isArray(rec) && rec.base_routes_anlsysis) return safeParse(rec.base_routes_anlsysis);
        return Array.isArray(rec) ? rec : [];
    }
    return normaliseRecords(rec);
}

// Colours used to distinguish overlaid routes on a single map.
var ROUTE_COLORS = ['#2c7be5', '#e74c3c', '#28a745', '#e67e22', '#8e44ad',
    '#16a085', '#d63384', '#f39c12', '#0dcaf0', '#6610f2'];

// Max number of routes that can be overlaid/plotted on the map at once.
var MAX_MAP_PLOTS = 3;

// ag-grid sidebar with the Columns + Filters tool panels (enterprise).
var SIDE_BAR_DEF = {
    toolPanels: [
        {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
        },
        {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
        },
    ],
};

// Convert an array of GPS points to a clean [{lat,lng}] list.
function ptsFromArray(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.map(function (p) {
        return {
            lat: parseFloat(p.lat !== undefined ? p.lat : p.latitude),
            lng: parseFloat(p.lng !== undefined ? p.lng : p.longitude)
        };
    }).filter(function (p) { return !isNaN(p.lat) && !isNaN(p.lng); });
}

// Turn a 'YYYY-MM-DD HH:mm:ss' string into a sortable number (null if not that).
function dateToComparable(value) {
    if (!value || value.length !== 19) return null;
    var n = Number(
        value.substring(0, 4)   // YYYY
        + value.substring(5, 7)   // MM
        + value.substring(8, 10)  // DD
        + value.substring(11, 13) // HH
        + value.substring(14, 16) // mm
        + value.substring(17, 19) // ss
    );
    return isNaN(n) ? null : n;
}

// ag-grid comparator for columns formatted as 'YYYY-MM-DD HH:mm:ss'. Blanks sort first.
function dateComparator(a, b) {
    var na = dateToComparable(a);
    var nb = dateToComparable(b);
    if (na === null && nb === null) return 0;
    if (na === null) return -1;
    if (nb === null) return 1;
    return na - nb;
}

// String cell renderer for the per-row "show on map" icon (icofont map-pins).
function mapPinCell() {
    return "<i class='icofont icofont-map-pins orn-action-icon' title='Show on map' "
        + "style='cursor:pointer;font-size:18px;color:#2c7be5'></i>";
}

export default function OptimiseRoutesNew(props) {
    // ── Loader / alert state ──────────────────────────────────────────────────
    var [loadshow, setLoadshow] = useState('show-n');
    var [overly, setOverly] = useState('show-n');
    var [show, setShow] = useState(false);
    var [basicTitle, setBasicTitle] = useState('');
    var [basicType, setBasicType] = useState('default');

    // ── Dept code ─────────────────────────────────────────────────────────────
    var [dept_code, setDeptCode] = useState('SNDG');

    // ── Dropdown option lists ─────────────────────────────────────────────────
    var [originoptions, setOriginoptions] = useState([{ label: "ALL", value: "ALL" }]);
    var [destinationOptions, setDestinationOptions] = useState([{ label: "ALL", value: "ALL" }]);
    var [lspusers_options, setLspusersOptions] = useState([{ label: "ALL", value: "ALL" }]);
    var [truck_types, setTruckTypes] = useState([{ label: "ALL", value: "ALL" }]);
    var [zonesOptions, setZonesOptions] = useState([{ label: "ALL", value: "ALL" }]);
    var [consignee_area_options, setConsigneeAreaOptions] = useState([{ label: "ALL", value: "ALL" }]);

    // ── Selected filter values (mirrors routedeviationoptimizeComponent.js) ───
    var [originoption, setOriginoption] = useState({ label: "ALL", value: "ALL" });
    var [destinationoption, setDestinationoption] = useState({ label: "ALL", value: "ALL" });
    var [selected_provider, setSelectedProvider] = useState({ label: "ALL", value: "ALL" });
    var [selected_truck_type, setSelectedTruckType] = useState({ label: "ALL", value: "ALL" });
    var [selectedZone, setSelectedZone] = useState({ label: "ALL", value: "ALL" });
    var [selectedConsArea, setSelectedConsArea] = useState({ label: "ALL", value: "ALL" });

    // ── Year / Quarter / Custom Date Range ────────────────────────────────────
    var [selected_year, setSelectedYear] = useState({ label: String(_currentYear), value: String(_currentYear) });
    var [selected_quarter, setSelectedQuarter] = useState({ label: "Q1", value: "Q1" });
    var [use_custom_date_range, setUseCustomDateRange] = useState(false);
    var [from_date, setFromDate] = useState('');
    var [to_date, setToDate] = useState('');

    // ── Grid row data ─────────────────────────────────────────────────────────
    var [rowData, setRowData] = useState([]);

    // ── Email-report popup state ──────────────────────────────────────────────
    var [showReportModal, setShowReportModal] = useState(false);
    var [emailInput, setEmailInput] = useState('');
    var [emailList, setEmailList] = useState([]);

    // ── Detail slider state (map / grid drill-down) ───────────────────────────
    var [sliderTranslate, setSliderTranslate] = useState('');
    var [sliderMode, setSliderMode] = useState('grid'); // 'grid' | 'map'
    var [sliderGridType, setSliderGridType] = useState(''); // consignments|baseroutes|ignored|top
    var [sliderTitle, setSliderTitle] = useState('');
    var [sliderRowData, setSliderRowData] = useState([]);
    var [sliderColDefs, setSliderColDefs] = useState([]);
    var [mapLegend, setMapLegend] = useState([]); // [{label,color}] shown above the map

    var gridApiRef = useRef(null);
    var mapScriptLoaded = useRef(false);
    var plantNameRef = useRef({}); // plant_code -> plant_name
    var plantCoordRef = useRef({}); // plant_code -> {lat,lng}
    var sliderGridApiRef = useRef(null); // ag-grid api for the slider grid
    var sliderGridTypeRef = useRef('');  // latest grid type (avoids stale closures)
    var routeGroupsRef = useRef([]);     // [{label,color,coords,markers}] to plot
    var mapToken = useRef(0);            // invalidates stale deferred map renders
    var mapDivRef = useRef(null);        // persistent map container (never unmounted)
    var mapInstanceRef = useRef(null);   // single google.maps.Map instance (reused)
    var mapOverlaysRef = useRef([]);     // polylines/markers currently drawn (to clear)
    var gridTitleRef = useRef('');       // last drill-down grid title (to restore from map)

    var defaultColDef = useMemo(function () {
        return { sortable: true, filter: true, resizable: true, autoHeight: true, width: 130 };
    }, []);

    // ── Initial data load (same three APIs as routedeviationoptimizeComponent) ─
    useEffect(function () {
        var dcCode = (props.match && props.match.path === "/optimiseroutes_new_prt") ? "LOG-PRT" : "SNDG";
        setDeptCode(dcCode);
        setLoadshow("show-m");
        setOverly("show-m");
        // 1) Plant mapping → code→name + code→coords (used for labels & map source marker)
        redirectURL.post("/consignments/get_plants_mapping", { dept_code: dcCode })
            .then(function (res) {
                var nameMap = {}, coordMap = {};
                (res.data || []).forEach(function (p) {
                    if (!p || !p.plant_code) return;
                    nameMap[p.plant_code] = p.plant_name || p.plant_code;
                    var c = safeParse(p.plant_coordinates);
                    if (c && c.lat !== undefined && c.lng !== undefined) {
                        coordMap[p.plant_code] = { lat: parseFloat(c.lat), lng: parseFloat(c.lng) };
                    }
                });
                plantNameRef.current = nameMap;
                plantCoordRef.current = coordMap;
                return redirectURL.post("/dashboard/getSourceFromBaseRoutes", { dept_code: dcCode });
            })
            .then(function (res) {
                var names = plantNameRef.current || {};
                var originopts = [{ label: "ALL", value: "ALL" }];
                (res.data || []).forEach(function (item) {
                    if (!item || item.toUpperCase() === "ALL") return;
                    // Only list source codes that are configured plants (from
                    // get_plants_mapping). This drops stale/invalid codes (e.g. "HN4N")
                    // that exist in base-route data but aren't real plants, and labels
                    // come straight from the API — no hardcoded plant map.
                    if (!names[item]) return;
                    originopts.push({ value: item, label: names[item] });
                });
                setOriginoptions(originopts);
                return redirectURL.post("dashboard/getDestinationFromRouteAnalytics", { consigner_code: "", dept_code: dcCode });
            })
            .then(function (res) {
                var destOpts = [{ label: "ALL", value: "ALL" }];
                (res.data || []).forEach(function (item) {
                    if (item && item.toUpperCase() !== "ALL") {
                        destOpts.push({ value: item, label: item });
                    }
                });
                setDestinationOptions(destOpts);
                return redirectURL.post("dashboard/getDropDownForBaseRouteOptimisedNew", { dept_code: dcCode });
            })
            .then(function (res) {
                var data = res.data || {};

                var lspOpts = [{ label: "ALL", value: "ALL" }];
                (data.lsp_users || []).forEach(function (e) {
                    if (e && e !== "NA" && e.toUpperCase() !== "ALL") {
                        var lbl = (e === "AXESTRACK_SND" || e === "AXESTRACK_PRT") ? "AXESTRACK" : e;
                        lspOpts.push({ label: lbl, value: e });
                    }
                });
                setLspusersOptions(lspOpts);

                var truckOpts = [{ label: "ALL", value: "ALL" }];
                (data.truck_types || []).forEach(function (e) {
                    if (e && e.toUpperCase() !== "ALL") { truckOpts.push({ label: e, value: e }); }
                });
                setTruckTypes(truckOpts);

                var zoneOpts = [{ label: "ALL", value: "ALL" }];
                (data.zones || []).forEach(function (e) {
                    if (e && e.toUpperCase() !== "ALL") { zoneOpts.push({ label: e, value: e }); }
                });
                setZonesOptions(zoneOpts);

                var areaOpts = [{ label: "ALL", value: "ALL" }];
                (data.consignee_areas || []).forEach(function (e) {
                    if (e && e.toUpperCase() !== "ALL") { areaOpts.push({ label: e, value: e }); }
                });
                setConsigneeAreaOptions(areaOpts);

                setLoadshow("show-n");
                setOverly("show-n");
            })
            .catch(function (err) {
                console.error("Initial data load failed", err);
                setLoadshow("show-n");
                setOverly("show-n");
            });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Build query from current filter state ─────────────────────────────────
    var buildQuery = useCallback(function () {
        var query = {
            truck_type: selected_truck_type.value,
            gps_provider: selected_provider.value,
            period_type: "ALL",
        };

        if (use_custom_date_range) {
            if (from_date) query.from_date = from_date;
            if (to_date) query.to_date = to_date;
        } else {
            query.quarter = selected_year.value + "-" + selected_quarter.value;
        }

        if (originoption.value && originoption.value !== "ALL") {
            query.sl_codes = [originoption.value];
        }
        if (destinationoption.value && destinationoption.value !== "ALL") {
            query.dl_city = destinationoption.value;
        }
        if (selectedConsArea.value && selectedConsArea.value !== "ALL") {
            query.dl_area = selectedConsArea.value;
        }
        if (selectedZone.value && selectedZone.value !== "ALL") {
            query.zone = selectedZone.value;
        }

        return query;
    }, [use_custom_date_range, from_date, to_date, selected_year, selected_quarter,
        selected_provider, selected_truck_type, originoption, destinationoption, selectedConsArea, selectedZone]);

    // ── Fetch optimized routes data ───────────────────────────────────────────
    var fetchData = useCallback(function () {
        setLoadshow("show-m");
        setOverly("show-m");

        redirectURL.post(ML_ENDPOINT, buildQuery())
            .then(function (response) {
                var rawData = response.data && response.data.data;

                if (!rawData || rawData === "undefined" || rawData === "null") {
                    setBasicTitle("No data found for the selected filters.");
                    setBasicType("warning");
                    setShow(true);
                    setRowData([]);
                    setLoadshow("show-n");
                    setOverly("show-n");
                    return;
                }

                var rec;
                try { rec = JSON.parse(rawData); } catch (e) { rec = rawData; }

                setRowData(normaliseRecords(rec));
                setLoadshow("show-n");
                setOverly("show-n");
            })
            .catch(function (err) {
                console.error("ML optimized routes error:", err);
                setBasicTitle("Failed to fetch data. Please try again.");
                setBasicType("danger");
                setShow(true);
                setLoadshow("show-n");
                setOverly("show-n");
            });
    }, [buildQuery]);

    // ── Submit button handler ─────────────────────────────────────────────────
    var onSubmit = useCallback(function () {
        if (use_custom_date_range && from_date && to_date && from_date > to_date) {
            setBasicTitle("'From Date' must be earlier than or equal to 'To Date'.");
            setBasicType("warning");
            setShow(true);
            return;
        }
        fetchData();
    }, [use_custom_date_range, from_date, to_date, fetchData]);

    // ── Toggle custom date range ──────────────────────────────────────────────
    var toggleCustomDateRange = useCallback(function () {
        setUseCustomDateRange(function (prev) { return !prev; });
        setFromDate('');
        setToDate('');
    }, []);

    // ── Email-report popup handlers ───────────────────────────────────────────
    var openReportModal = useCallback(function () {
        setEmailInput('');
        setEmailList([]);
        setShowReportModal(true);
    }, []);

    var closeReportModal = useCallback(function () {
        setShowReportModal(false);
    }, []);

    var addEmail = useCallback(function () {
        var e = (emailInput || '').trim().toLowerCase();
        if (!e) return;
        if (!EMAIL_RE.test(e)) {
            setBasicTitle("Please enter a valid email address.");
            setBasicType("warning");
            setShow(true);
            return;
        }
        setEmailList(function (prev) { return prev.indexOf(e) === -1 ? prev.concat(e) : prev; });
        setEmailInput('');
    }, [emailInput]);

    var removeEmail = useCallback(function (target) {
        setEmailList(function (prev) { return prev.filter(function (x) { return x !== target; }); });
    }, []);

    // Build the recipient list, folding in any valid email still typed but not
    // yet added (so the user doesn't have to click "Add" before "Send").
    var onSendReport = useCallback(function () {
        var emails = emailList.slice();
        var pending = (emailInput || '').trim().toLowerCase();
        if (pending) {
            if (!EMAIL_RE.test(pending)) {
                setBasicTitle("Please enter a valid email address.");
                setBasicType("warning");
                setShow(true);
                return;
            }
            if (emails.indexOf(pending) === -1) emails.push(pending);
        }
        if (!emails.length) {
            setBasicTitle("Please add at least one valid email address.");
            setBasicType("warning");
            setShow(true);
            return;
        }
        if (use_custom_date_range && from_date && to_date && from_date > to_date) {
            setBasicTitle("'From Date' must be earlier than or equal to 'To Date'.");
            setBasicType("warning");
            setShow(true);
            return;
        }

        // Same filter payload the grid uses, plus the email-report fields.
        var payload = buildQuery();
        payload.emails = emails;
        payload.include_legs = 1;

        setShowReportModal(false);
        setLoadshow("show-m");
        setOverly("show-m");
        redirectURL.post("/consignments/ml_optimized_base_routes_email", payload)
            .then(function () {
                setLoadshow("show-n");
                setOverly("show-n");
                setBasicTitle("Report is being generated and will be emailed to: " + emails.join(", "));
                setBasicType("success");
                setShow(true);
                setEmailList([]);
                setEmailInput('');
            })
            .catch(function (err) {
                console.error("Email report error:", err);
                setLoadshow("show-n");
                setOverly("show-n");
                setBasicTitle("Failed to send the report. Please try again.");
                setBasicType("danger");
                setShow(true);
            });
    }, [emailInput, emailList, buildQuery, use_custom_date_range, from_date, to_date]);

    var onGridReady = function (params) { gridApiRef.current = params.api; };

    // ── Detail column definitions (slider grids) — fields per real API output ─
    // Selection + per-row "show on map" columns (consignments & base routes).
    var checkboxCol = {
        headerName: "", field: "_check", width: 46, pinned: "left",
        sortable: false, filter: false, suppressMenu: true,
        checkboxSelection: true, headerCheckboxSelection: true,
    };
    var mapIconCol = {
        headerName: "Map", field: "_rowmap", width: 60, pinned: "left",
        sortable: false, filter: false, cellClass: "orn-icon-cell", cellRenderer: mapPinCell,
    };

    // Per-trip columns (consignments_analysis & ignored share these).
    var tripCommonCols = [
        { headerName: "Invoice No", field: "invoice_no", width: 130 },
        { headerName: "Shipment ID", field: "shipment_id", width: 140 },
        { headerName: "Vehicle No", field: "vehicle_no", width: 120 },
        { headerName: "Transporter", field: "tpt_name", width: 220 },
        { headerName: "Dest Code", field: "dl_code", width: 105 },
        { headerName: "Dest Name", field: "dl_name", width: 180 },
        { headerName: "Dest City", field: "dl_city", width: 120 },
        { headerName: "GPS Distance (Km)", field: "ttd_std_km", width: 145 },
        { headerName: "SAP Distance (Km)", field: "dist_btw_s_d", width: 145 },
        { headerName: "Zone", field: "zone", width: 95 },
    ];

    // Trip End date — formatted as 'YYYY-MM-DD HH:mm:ss' via valueGetter so the
    // grid cell AND the column/filter use the same display value, with a proper
    // date comparator for sorting. A factory (not a shared object) so each grid
    // gets its own colDef instance — ag-grid mutates colDefs, so sharing one
    // reference across grids bleeds sort/width/order state between them.
    var tripEndCol = function () {
        return {
            headerName: "Trip End", field: "trip_end_time", width: 175,
            valueGetter: function (p) { return getHyphenYYYYMMDDHHMMSS(p.data && p.data.trip_end_time); },
            comparator: dateComparator,
        };
    };

    var LEGS_COLS = useMemo(function () {
        return {
            // Consignments → consignments_analysis (checkbox + per-row map)
            consignments: [checkboxCol, mapIconCol].concat(tripCommonCols).concat([
                { headerName: "Base Route", field: "base_route_no", width: 140 },
                { headerName: "Is Base Route", field: "is_base_route", width: 120 },
                { headerName: "Followers", field: "followed_route_count", width: 110 },
                { headerName: "Reason", field: "reason", width: 260 },
                { headerName: "No of Tolls", field: "number_of_tolls", width: 100 },
                { headerName: "Total Toll Cost", field: "total_toll_cost", width: 140 },
                tripEndCol(),
            ]),
            // Base Routes → base_routes_anlsysis (checkbox + per-row map)
            baseroutes: [checkboxCol, mapIconCol].concat([
                {
                    headerName: "Base Route", field: "base_route_no", width: 130,
                    valueGetter: function (p) {
                        return (p.data && p.data.base_route_no !== undefined && p.data.base_route_no !== null)
                            ? ("Base Route " + p.data.base_route_no) : "";
                    }
                },
                { headerName: "Source", field: "sl_code", width: 110 },
                { headerName: "Destination", field: "dl_city", width: 120 },
                { headerName: "SAP Distance (Km)", field: "expected_distance", width: 150 },
                { headerName: "Min GPS (Km)", field: "min_google_distance", width: 130 },
                { headerName: "Max GPS (Km)", field: "max_google_distance", width: 130 },
                { headerName: "Avg GPS (Km)", field: "avg_google_distance", width: 130 },
                { headerName: "Median GPS (Km)", field: "median_google_distance", width: 145 },
                { headerName: "Base Route GPS Dist (Km)", field: "base_route_gps_distance", width: 180 },
                { headerName: "No. of Followers", field: "no_of_followers", width: 135 },
                {
                    headerName: "Invoice No", field: "invoice_no", width: 160,
                    valueGetter: function (p) {
                        var v = p.data && p.data.invoice_no;
                        return Array.isArray(v) ? v.join(", ") : (v || "");
                    }
                },
                tripEndCol(),
            ]),
            // Ignored Routes → flat array (no checkbox / map)
            ignored: tripCommonCols.concat([
                { headerName: "Route Ignored", field: "route_ignored", width: 125 },
                { headerName: "Reason", field: "reason", width: 320 },
                tripEndCol(),
            ]),
            // Top Routes (Unique Trips) — verify vs real data
            top: tripCommonCols.concat([
                { headerName: "Base Route", field: "base_route_no", width: 140 },
                tripEndCol(),
            ]),
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Per-row legs payload (current date filters + sl_code + dl_city) ───────
    var buildDetailPayload = useCallback(function (mode, row) {
        var fd = {};
        if (use_custom_date_range) {
            if (from_date) fd.from_date = from_date;
            if (to_date) fd.to_date = to_date;
        } else {
            fd.quarter = selected_year.value + "-" + selected_quarter.value;
        }
        if (row && row.sl_code) fd.sl_code = row.sl_code; // string, per API contract
        if (row && row.dl_city) fd.dl_city = row.dl_city;
        if (mode === 'consignments') fd.consignments_data = 1; // populates consignments_analysis
        return fd;
    }, [use_custom_date_range, from_date, to_date, selected_year, selected_quarter]);

    // ── Per-consignment map payload for /consignments/maproutes ───────────────
    var buildConsignmentMapPayload = useCallback(function (r) {
        return {
            truck_no: (r && r.vehicle_no) || "",
            gate_out_time: (r && r.sl_exit_dt) || "",
            seconddate: (r && r.trip_end_time) || "",
            consignment_code: (r && r.invoice_no) || "",
            consignee_code: (r && r.dl_code) || "",
            screen: "consignment",
            // Identifies this screen so the node API normalises the dates and
            // forces the elis base route only for optimise-routes requests,
            // leaving every other /consignments/maproutes caller unchanged.
            source_screen: "optimiseroutes",
            fetch_address: 0,
            dept_code: (r && r.dept_code) || dept_code,
        };
    }, [dept_code]);

    // ── Close slider (also clears any rendered map) ───────────────────────────
    var onCloseSlider = useCallback(function () {
        mapToken.current += 1;       // invalidate any pending deferred map render
        routeGroupsRef.current = [];
        setSliderTranslate('');
        setSliderMode('grid');
        setMapLegend([]);
        setOverly('show-n');
    }, []);

    // ── Map → back to the drill-down grid it was opened from (without closing) ─
    var onBackToGrid = useCallback(function () {
        mapToken.current += 1;       // cancel any pending deferred map render
        routeGroupsRef.current = [];
        (mapOverlaysRef.current || []).forEach(function (o) {
            try { o.setMap(null); } catch (e) { /* noop */ }
        });
        mapOverlaysRef.current = [];
        setMapLegend([]);
        setSliderMode('grid');
        setSliderTitle(gridTitleRef.current || '');
        setSliderTranslate('slider-translate-60p');   // keep slider + overlay open
    }, []);

    // ── Context-aware close button: map view steps back to the grid, grid view
    //    closes the whole slider. Fixes "closing the map also closed the grid". ─
    var onSliderCloseClick = useCallback(function () {
        if (sliderMode === 'map') onBackToGrid();
        else onCloseSlider();
    }, [sliderMode, onBackToGrid, onCloseSlider]);

    // ── Open a legs drill-down (consignments / baseroutes / ignored / top) ────
    var openLegsGrid = useCallback(function (gridType, title, row) {
        // Flip to grid mode immediately so any open map is hidden (the map
        // container stays mounted, we just toggle its CSS visibility).
        mapToken.current += 1;
        routeGroupsRef.current = [];
        setMapLegend([]);
        setSliderMode('grid');
        setSliderGridType(gridType);
        sliderGridTypeRef.current = gridType;
        setLoadshow('show-m');
        setOverly('show-m');

        var endpoint;
        if (gridType === 'consignments' || gridType === 'baseroutes') {
            endpoint = '/consignments/ml_route_deviation_analysis';
        } else if (gridType === 'ignored') {
            endpoint = '/consignments/ml_ignored_routes';
        } else {
            endpoint = '/consignments/ml_top_routes_unique_trips';
        }

        redirectURL.post(endpoint, buildDetailPayload(gridType, row))
            .then(function (response) {
                var rawData = response.data && response.data.data;
                var rec;
                try { rec = JSON.parse(rawData); } catch (e) { rec = rawData; }
                var records = normaliseLegs(rec, gridType);
                var fullTitle = title + " — " + (row.sl_name || row.sl_code || "")
                    + (row.dl_city ? " → " + row.dl_city : "");
                gridTitleRef.current = fullTitle;   // remembered for map → back navigation
                setSliderTitle(fullTitle);
                setSliderColDefs(LEGS_COLS[gridType] || []);
                setSliderRowData(records);
                setLoadshow('show-n');
                if (!records.length) {
                    // Nothing to drill into: keep slider + overlay closed together so
                    // they never diverge (no half-open slider behind a missing backdrop).
                    setSliderTranslate('');
                    setOverly('show-n');
                    setBasicTitle("No records found for this route.");
                    setBasicType("info");
                    setShow(true);
                } else {
                    setSliderTranslate('slider-translate-60p');   // overlay already shown
                }
            })
            .catch(function (err) {
                console.error("Legs fetch error:", gridType, err);
                setBasicTitle("Failed to load " + title + ".");
                setBasicType("danger");
                setShow(true);
                setLoadshow('show-n');
                setOverly('show-n');
            });
    }, [buildDetailPayload, LEGS_COLS]);

    // ── Plot the queued route groups (overlaid, colour-coded) on the map ──────
    var plotRouteGroups = useCallback(function () {
        // Use the persistent container ref; bail out if it isn't mounted/attached.
        var el = mapDivRef.current || document.getElementById('ornMap');
        if (!el || !el.isConnected || !window.google || !window.google.maps) return;

        var groups = routeGroupsRef.current || [];

        // Create the Map exactly once and reuse it. Re-creating a Map on a div
        // that React keeps swapping is what triggers the Google Maps
        // "IntersectionObserver: parameter 1 is not of type 'Element'" crash.
        var map = mapInstanceRef.current;
        if (!map) {
            map = new window.google.maps.Map(el, {
                zoom: 7,
                center: new window.google.maps.LatLng(28.497236, 77.062363),
                mapTypeId: window.google.maps.MapTypeId.ROADMAP,
                mapTypeControl: true,
                fullscreenControl: true,
                zoomControl: true,
            });
            mapInstanceRef.current = map;
        }

        // Clear whatever was drawn on the previous plot.
        (mapOverlaysRef.current || []).forEach(function (o) {
            try { o.setMap(null); } catch (e) { /* noop */ }
        });
        mapOverlaysRef.current = [];

        var bounds = new window.google.maps.LatLngBounds();
        var any = false;

        groups.forEach(function (g) {
            if (g.coords && g.coords.length) {
                var path = g.coords.map(function (p) {
                    return new window.google.maps.LatLng(p.lat, p.lng);
                });
                path.forEach(function (pt) { bounds.extend(pt); any = true; });
                mapOverlaysRef.current.push(new window.google.maps.Polyline({
                    path: path, geodesic: true, strokeColor: g.color,
                    strokeOpacity: 0.9, strokeWeight: 4, map: map,
                }));
                mapOverlaysRef.current.push(new window.google.maps.Marker({ position: path[0], map: map, label: 'S', title: (g.label || '') + ' Start' }));
                mapOverlaysRef.current.push(new window.google.maps.Marker({ position: path[path.length - 1], map: map, label: 'E', title: (g.label || '') + ' End' }));
            }
            (g.markers || []).forEach(function (m) {
                if (isNaN(m.lat) || isNaN(m.lng)) return;
                var pos = new window.google.maps.LatLng(m.lat, m.lng);
                bounds.extend(pos); any = true;
                var opts = { position: pos, map: map, title: m.title || '' };
                if (m.kind === 'source' || m.kind === 'dest') {
                    opts.icon = {
                        path: window.google.maps.SymbolPath.CIRCLE, scale: 7,
                        fillColor: m.kind === 'source' ? '#28a745' : '#d6336c',
                        fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2,
                    };
                } else if (m.kind === 'break') {
                    opts.icon = {
                        path: window.google.maps.SymbolPath.CIRCLE, scale: 5,
                        fillColor: '#f39c12', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 1,
                    };
                }
                mapOverlaysRef.current.push(new window.google.maps.Marker(opts));
            });
        });

        // The container was hidden (CSS) until now, so nudge Maps to remeasure
        // before fitting the bounds, otherwise the tiles render at 0×0.
        window.google.maps.event.trigger(map, 'resize');
        if (any) {
            map.fitBounds(bounds);
        } else {
            map.setCenter(new window.google.maps.LatLng(28.497236, 77.062363));
            map.setZoom(7);
        }
    }, []);

    var renderOrnMap = useCallback(function () {
        if (window.google && window.google.maps) {
            plotRouteGroups();
            return;
        }
        window.initOrnMap = plotRouteGroups;
        if (!mapScriptLoaded.current) {
            mapScriptLoaded.current = true;
            loadScript("https://maps.googleapis.com/maps/api/js?key=" + gMap.API_KEY
                + "&libraries=places,drawing,geometry&callback=initOrnMap");
        }
    }, [plotRouteGroups]);

    // ── Switch the slider into map mode and (deferred) draw the queued routes ─
    var switchToMap = useCallback(function (title) {
        mapToken.current += 1;
        var myToken = mapToken.current;
        setMapLegend((routeGroupsRef.current || []).map(function (g) {
            return { label: g.label, color: g.color };
        }));
        setSliderMode('map');
        setSliderTitle(title);
        setSliderTranslate('slider-translate-75p');
        setLoadshow('show-n');
        setOverly('show-m');
        setTimeout(function () { if (myToken === mapToken.current) renderOrnMap(); }, 450);
    }, [renderOrnMap]);

    // ── Plot one-or-more base routes (via /consignments/ml_route_in_ra) ───────
    var plotBaseRoutes = useCallback(function (rows) {
        if (!rows || !rows.length) return;
        setLoadshow('show-m');
        setOverly('show-m');
        Promise.all(rows.map(function (r, i) {
            // ml_route_in_ra returns { status, data: "[{lat,lng,truck_no,timestamp},...]" }
            return redirectURL.post('/consignments/ml_route_in_ra', { s3_filename: r.s3_filename })
                .then(function (resp) {
                    var coordsRaw = resp.data && resp.data.data;
                    return {
                        label: 'Base Route ' + (r.base_route_no !== undefined ? r.base_route_no : (i + 1)),
                        color: ROUTE_COLORS[i % ROUTE_COLORS.length],
                        coords: ptsFromArray(safeParse(coordsRaw)),
                        markers: [],
                    };
                })
                .catch(function () { return null; });
        })).then(function (groups) {
            groups = groups.filter(Boolean);
            routeGroupsRef.current = groups;
            var hasData = groups.some(function (g) { return g.coords.length; });
            switchToMap('Base Routes Map');
            if (!hasData) {
                setBasicTitle("No GPS trace found for the selected base route(s).");
                setBasicType("info");
                setShow(true);
            }
        }).catch(function (err) {
            console.error("Base route map error:", err);
            setLoadshow('show-n');
            setOverly('show-n');
        });
    }, [switchToMap]);

    // ── Plot one-or-more consignments (via /consignments/maproutes) ───────────
    var plotConsignments = useCallback(function (rows) {
        if (!rows || !rows.length) return;
        setLoadshow('show-m');
        setOverly('show-m');
        Promise.all(rows.map(function (r, i) {
            return redirectURL.post('/consignments/maproutes', buildConsignmentMapPayload(r))
                .then(function (resp) {
                    var d = resp.data;
                    if (typeof d === 'string') { try { d = JSON.parse(d); } catch (e) { d = {}; } }
                    d = d || {};
                    var markers = [];
                    if (d.consigner_coordinates && d.consigner_coordinates.lat !== undefined) {
                        markers.push({
                            lat: parseFloat(d.consigner_coordinates.lat), lng: parseFloat(d.consigner_coordinates.lng),
                            kind: 'source', title: 'Source: ' + (d.consigner_coordinates.name || ''),
                        });
                    }
                    if (d.consignee_coordinates && d.consignee_coordinates.lat !== undefined) {
                        markers.push({
                            lat: parseFloat(d.consignee_coordinates.lat), lng: parseFloat(d.consignee_coordinates.lng),
                            kind: 'dest', title: 'Dealer: ' + (d.consignee_coordinates.name || ''),
                        });
                    }
                    (d.breaks || []).forEach(function (b) {
                        markers.push({ lat: parseFloat(b.lat), lng: parseFloat(b.lng), kind: 'break', title: 'Break' });
                    });
                    return {
                        label: (r.vehicle_no || '') + ' / ' + (r.invoice_no || ''),
                        color: ROUTE_COLORS[i % ROUTE_COLORS.length],
                        coords: ptsFromArray(d.coords || []),
                        markers: markers,
                    };
                })
                .catch(function () { return null; });
        })).then(function (groups) {
            groups = groups.filter(Boolean);
            routeGroupsRef.current = groups;
            var hasData = groups.some(function (g) { return g.coords.length || (g.markers && g.markers.length); });
            switchToMap('Consignments Map');
            if (!hasData) {
                setBasicTitle("No GPS data found for the selected consignment(s).");
                setBasicType("info");
                setShow(true);
            }
        }).catch(function (err) {
            console.error("Consignment map error:", err);
            setLoadshow('show-n');
            setOverly('show-n');
        });
    }, [buildConsignmentMapPayload, switchToMap]);

    // ── Slider grid: capture api + handle the per-row map icon click ──────────
    var onSliderGridReady = function (params) { sliderGridApiRef.current = params.api; };

    var onLegCellClicked = useCallback(function (params) {
        if (!params.colDef || params.colDef.field !== '_rowmap') return;
        var gt = sliderGridTypeRef.current;
        if (gt === 'baseroutes') plotBaseRoutes([params.data]);
        else if (gt === 'consignments') plotConsignments([params.data]);
    }, [plotBaseRoutes, plotConsignments]);

    // ── "Show Map" button → plot all checked rows overlaid ────────────────────
    var onShowMap = useCallback(function () {
        var api = sliderGridApiRef.current;
        var rows = api ? api.getSelectedRows() : [];
        if (!rows.length) {
            setBasicTitle("Please select at least one row.");
            setBasicType("warning");
            setShow(true);
            return;
        }
        if (rows.length > MAX_MAP_PLOTS) {
            setBasicTitle("You can plot at most " + MAX_MAP_PLOTS
                + " routes on the map at a time. Please select " + MAX_MAP_PLOTS + " or fewer.");
            setBasicType("warning");
            setShow(true);
            return;
        }
        var gt = sliderGridTypeRef.current;
        if (gt === 'baseroutes') plotBaseRoutes(rows);
        else if (gt === 'consignments') plotConsignments(rows);
    }, [plotBaseRoutes, plotConsignments]);

    // ── Main-grid cell click → open the correct legs drill-down ───────────────
    var onCellClicked = useCallback(function (params) {
        var f = params.colDef && params.colDef.field;
        if (f === 'consignments') {
            openLegsGrid('consignments', 'Consignments', params.data);
        } else if (f === 'baseroutes') {
            openLegsGrid('baseroutes', 'Base Routes', params.data);
        } else if (f === '_ignored') {
            openLegsGrid('ignored', 'Ignored Routes', params.data);
        } else if (f === '_top') {
            openLegsGrid('top', 'Top Routes (Unique Trips)', params.data);
        }
    }, [openLegsGrid]);

    // ── Column definitions per tab ────────────────────────────────────────────
    var periodParam = use_custom_date_range
        ? ("&from_date=" + from_date + "&to_date=" + to_date)
        : ("&quarter=" + encodeURIComponent(selected_year.value + "-" + selected_quarter.value));
    var extraParam = "&period_type=ALL"
        + "&gps_provider=" + encodeURIComponent(selected_provider.value)
        + "&truck_type=" + encodeURIComponent(selected_truck_type.value);
    var summaryBasePath = "/deviationanalysisdata";

    var viewSummaryBtn = {
        headerName: "",
        field: "_action",
        width: 140,
        cellRenderer: function (params) {
            var sourval = params.data.sl_code || "";
            var srcname = encodeURIComponent(params.data.sl_name || "");
            var dest = encodeURIComponent(params.data.dl_city || "");
            var href = summaryBasePath
                + "?source=" + sourval
                + "&sourcename=" + srcname
                + "&destination=" + dest
                + "&destField=dl_code"
                + extraParam
                + periodParam;
            return '<a href="' + href + '" target="_blank" rel="noopener" '
                + 'class="btn orn-summary-btn">'
                + '<i class="fa fa-bar-chart"></i>View Summary</a>';
        }
    };

    var commonRouteCols = [
        { headerName: "Source", field: "sl_name", width: 130 },
        { headerName: "Destination", field: "dl_city", width: 120 },
        // { headerName: "Destination Name",         field: "dl_name",                              width: 180 },
        { headerName: "Total Source Dest Trips", field: "total_trip_btw_source_dest", width: 150 },
        { headerName: "Valid Trips", field: "no_of_valid_trips", width: 110 },
        { headerName: "Ignored Trips", field: "no_of_ignored_trips", width: 110 },
        { headerName: "SAP Distance (Km)", field: "dist_btw_s_d", width: 130 },
        { headerName: "Min GPS Distance (Km)", field: "ref_route_min_google_distance", width: 150 },
        { headerName: "Max GPS Distance (Km)", field: "ref_route_max_google_distance", width: 150 },
        { headerName: "Avg GPS Distance (Km)", field: "ref_route_avg_google_distance", width: 150 },
        { headerName: "Median GPS Distance (Km)", field: "ref_route_median_google_distance", width: 165 },
    ];

    // Clickable Font Awesome action icons (handled by onCellClicked).
    var actionIconCols = [
        {
            headerName: "Consignments", field: "consignments", width: 100, sortable: false, filter: false,
            cellClass: "orn-icon-cell", cellRenderer: iconCell('fa-sitemap', '#e67e22', 'View consignments')
        },
        {
            headerName: "Base Route", field: "baseroutes", width: 80, sortable: false, filter: false,
            cellClass: "orn-icon-cell", cellRenderer: iconCell('fa-code-fork', '#2c7be5', 'View base routes')
        },
        {
            headerName: "Ignored Routes", field: "_ignored", width: 100, sortable: false, filter: false,
            cellClass: "orn-icon-cell", cellRenderer: iconCell('fa-ban', '#e74c3c', 'View ignored routes')
        },
        // {
        //     headerName: "Top Routes", field: "_top", width: 105, sortable: false, filter: false,
        //     cellClass: "orn-icon-cell", cellRenderer: iconCell('fa-trophy', '#caa800', 'View top routes')
        // },
    ];

    var columnDefs = useMemo(function () {
        return [].concat(actionIconCols).concat(commonRouteCols).concat([
            // { headerName: "Optimized Distance (Km)", field: "google_distance_via_waypoints", width: 165 },
            { headerName: "Consignee Area", field: "dl_area", width: 130 },
            { headerName: "Zone", field: "zone", width: 100 },
            // { headerName: "Status",                  field: "route_approval_status",         width: 120 },
        ]);
    }, [periodParam, extraParam, summaryBasePath]); // eslint-disable-line react-hooks/exhaustive-deps

    // ── Render ────────────────────────────────────────────────────────────────
    return (
        <div className="container-fluid">
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={function () { setShow(false); }}
            />

            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h5>
                                <i className="icon-map cus-i"></i>&nbsp;
                                <span>Optimise Routes </span>
                            </h5>
                        </div>

                        <div className="card-body">

                            {/* ── Filter row ─────────────────────────────────── */}
                            <div className="row orn-filter-panel">

                                {/* Origin */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label>Origin</label>
                                    <Select
                                        name="originoption"
                                        value={originoption}
                                        options={originoptions}
                                        onChange={function (v) { setOriginoption(v); }}
                                    />
                                </div>

                                {/* Zone */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label>Zone</label>
                                    <Select
                                        name="zone"
                                        value={selectedZone}
                                        options={zonesOptions}
                                        onChange={function (v) { setSelectedZone(v); }}
                                    />
                                </div>

                                {/* Consignee Area */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label>Consignee Area</label>
                                    <Select
                                        name="consignee_area"
                                        value={selectedConsArea}
                                        options={consignee_area_options}
                                        onChange={function (v) { setSelectedConsArea(v); }}
                                    />
                                </div>

                                {/* Destination */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label>Destination</label>
                                    <Select
                                        name="destinationoption"
                                        value={destinationoption}
                                        options={destinationOptions}
                                        onChange={function (v) { setDestinationoption(v); }}
                                    />
                                </div>

                                {/* GPS Provider */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label>GPS Provider</label>
                                    <Select
                                        name="gps_provider"
                                        value={selected_provider}
                                        options={lspusers_options}
                                        onChange={function (v) { setSelectedProvider(v); }}
                                    />
                                </div>

                                {/* Truck Type */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label>Truck Type</label>
                                    <Select
                                        name="truck_type"
                                        value={selected_truck_type}
                                        options={truck_types}
                                        onChange={function (v) { setSelectedTruckType(v); }}
                                    />
                                </div>

                                {/* Year — visible when toggle OFF */}
                                {!use_custom_date_range && (
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>Year</label>
                                        <Select
                                            name="year"
                                            value={selected_year}
                                            options={YEAR_OPTIONS}
                                            onChange={function (v) { setSelectedYear(v); }}
                                        />
                                    </div>
                                )}

                                {/* Quarter — visible when toggle OFF */}
                                {!use_custom_date_range && (
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>Quarter</label>
                                        <Select
                                            name="quarter"
                                            value={selected_quarter}
                                            options={QUARTER_OPTIONS}
                                            onChange={function (v) { setSelectedQuarter(v); }}
                                        />
                                    </div>
                                )}

                                {/* From Date — visible when toggle ON */}
                                {use_custom_date_range && (
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>From Date</label>
                                        <input
                                            type="date"
                                            name="from_date"
                                            value={from_date}
                                            onChange={function (e) { setFromDate(e.target.value); }}
                                            className="form-control orn-date-input"
                                        />
                                    </div>
                                )}

                                {/* To Date — visible when toggle ON */}
                                {use_custom_date_range && (
                                    <div className="col-xl-2 col-lg-2 form-group">
                                        <label>To Date</label>
                                        <input
                                            type="date"
                                            name="to_date"
                                            value={to_date}
                                            onChange={function (e) { setToDate(e.target.value); }}
                                            className="form-control orn-date-input"
                                        />
                                    </div>
                                )}

                                {/* Custom Date Range toggle */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label className="orn-label-spacer">&nbsp;</label>
                                    <div className="orn-toggle-row">
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={use_custom_date_range}
                                                onChange={toggleCustomDateRange}
                                            />
                                            <span className="switch-state"></span>
                                        </label>
                                        <span className="orn-toggle-text">Custom Date Range</span>
                                    </div>
                                </div>

                                {/* Submit */}
                                <div className="col-xl-2 col-lg-2 form-group">
                                    <label className="orn-label-spacer">&nbsp;</label>
                                    <button
                                        type="button"
                                        className="btn btn-success orn-submit-btn"
                                        onClick={onSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>

                            {/* ── Report toolbar (top-right, above grid) ─────── */}
                            <div className="orn-report-toolbar">
                                <button
                                    type="button"
                                    className="btn orn-report-btn"
                                    onClick={openReportModal}
                                    title="Download / email the report"
                                >
                                    <i className="fa fa-download"></i>&nbsp;Download Report
                                </button>
                            </div>

                            {/* ── Grid ───────────────────────────────────────── */}
                            <div id="mlOptimiseGrid" className="ag-theme-balham orn-grid-container">
                                <AgGridReact
                                    modules={AllModules}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    rowData={rowData}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    animateRows={true}
                                    sideBar={SIDE_BAR_DEF}
                                    onGridReady={onGridReady}
                                    onCellClicked={onCellClicked}
                                    overlayNoRowsTemplate='<span style="padding:10px;color:#555">Select filters and click Submit to load data.</span>'
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* ── Detail slider (map / grid drill-down) ──────────────────── */}
            <div className={"slide-r " + sliderTranslate} style={{ overflow: "auto" }}>
                <div className="slide-r-title">
                    <h4>
                        {sliderMode === 'map' && (
                            <span
                                className="float-left"
                                style={{ marginLeft: "10px", marginRight: "15px", cursor: "pointer" }}
                                onClick={onBackToGrid}
                                title="Back to list"
                            >&larr; Back</span>
                        )}
                        {sliderTitle}
                        <span
                            className="float-right closebtn"
                            style={{ marginRight: "25px", cursor: "pointer" }}
                            onClick={onSliderCloseClick}
                        >X</span>
                    </h4>
                </div>
                <div className="slide-r-body" style={{ position: "relative" }}>
                    {/* Map view — kept permanently mounted (just hidden via CSS) so the
                        Google Map element/instance stays stable across open/close. */}
                    <div key="orn-map-view" style={{ display: sliderMode === 'map' ? 'block' : 'none' }}>
                        {mapLegend.length > 0 && (
                            <div className="orn-map-legend">
                                {mapLegend.map(function (g, i) {
                                    return (
                                        <span key={i} className="orn-map-legend-item">
                                            <span className="orn-map-legend-swatch"
                                                style={{ background: g.color }}></span>
                                            {g.label}
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                        <div id="ornMap" ref={mapDivRef} className="orn-map-canvas"></div>
                    </div>

                    {/* Grid view */}
                    {sliderMode !== 'map' && (
                        <div key="orn-grid-view">
                            {(sliderGridType === 'consignments' || sliderGridType === 'baseroutes') && (
                                <div className="orn-legs-toolbar">
                                    <button type="button" className="btn btn-primary btn-sm orn-showmap-btn"
                                        onClick={onShowMap}>
                                        <i className="icofont icofont-map-pins"></i>&nbsp; Show Map (selected)
                                    </button>
                                    <span className="orn-legs-hint">
                                        Tick up to {MAX_MAP_PLOTS} rows and click “Show Map”, or click the map icon on a single row.
                                    </span>
                                </div>
                            )}
                            <div className="ag-theme-balham orn-detail-grid">
                                <AgGridReact
                                    key={sliderGridType}
                                    modules={AllModules}
                                    columnDefs={sliderColDefs}
                                    defaultColDef={defaultColDef}
                                    rowData={sliderRowData}
                                    pagination={true}
                                    paginationPageSize={50}
                                    enableRangeSelection={true}
                                    animateRows={true}
                                    rowSelection="multiple"
                                    suppressRowClickSelection={true}
                                    sideBar={SIDE_BAR_DEF}
                                    onGridReady={onSliderGridReady}
                                    onCellClicked={onLegCellClicked}
                                    overlayNoRowsTemplate='<span style="padding:10px;color:#555">No records for this route.</span>'
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* ── Email report popup ─────────────────────────────────────── */}
            {showReportModal && (
                <div className="orn-modal-backdrop" onClick={closeReportModal}>
                    <div className="orn-modal" onClick={function (e) { e.stopPropagation(); }}>
                        <div className="orn-modal-header">
                            <h5><i className="fa fa-envelope"></i>&nbsp;Email Report</h5>
                            <span className="orn-modal-close" onClick={closeReportModal} title="Close">&times;</span>
                        </div>
                        <div className="orn-modal-body">
                            <label>Recipient Email(s)</label>
                            <div className="orn-email-input-row">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Enter an email and click Add"
                                    value={emailInput}
                                    onChange={function (e) { setEmailInput(e.target.value); }}
                                    onKeyDown={function (e) {
                                        if (e.key === 'Enter') { e.preventDefault(); addEmail(); }
                                    }}
                                />
                                <button type="button" className="btn orn-email-add-btn" onClick={addEmail}>Add</button>
                            </div>
                            {emailList.length > 0 && (
                                <div className="orn-email-chips">
                                    {emailList.map(function (e, i) {
                                        return (
                                            <span key={i} className="orn-email-chip">
                                                {e}
                                                <span className="orn-email-chip-x"
                                                    onClick={function () { removeEmail(e); }}
                                                    title="Remove">&times;</span>
                                            </span>
                                        );
                                    })}
                                </div>
                            )}
                            <p className="orn-modal-hint">
                                The report (Excel) will be generated for the currently selected filters
                                and emailed to the address(es) above.
                            </p>
                        </div>
                        <div className="orn-modal-footer">
                            <button type="button" className="btn orn-modal-cancel" onClick={closeReportModal}>
                                Cancel
                            </button>
                            <button type="button" className="btn orn-modal-send" onClick={onSendReport}>
                                <i className="fa fa-paper-plane"></i>&nbsp;Send Report
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Loader overlay ─────────────────────────────────────────── */}
            <div className={"dataLoadpage " + loadshow} />
            <div className={"dataLoadpageimg " + loadshow}>
                <div className="loader-box">
                    <div className="loader-box">
                        <div className="rotate dashed colored"></div>
                    </div>
                </div>
            </div>
            <div
                className={"overlay-part " + overly}
                onClick={function () {
                    setLoadshow('show-n');
                    // Mirror the close button: from the map step back to the grid,
                    // otherwise dismiss the whole slider + overlay together.
                    if (sliderMode === 'map') { onBackToGrid(); }
                    else { setOverly('show-n'); onCloseSlider(); }
                }}
            />
        </div>
    );
}
